import { Dropdown } from "react-bootstrap";
import styles from "../index.module.scss";
import cn from "../../../../../Utils/class-names.utils";
import { useEntity } from "../../../../../hooks/use-entity.hook";
import { PortlandReportEffectActions } from "../../../../../common/services/portland-report/portland-report.service";
import { Flaggers } from "../../../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../../../common/store/flaggers/flaggers.methods";
import { CustomDeleteModal } from "../../../../DeleteModal/DeleteModal";
import { HGHighlightText } from "../../../../App/App";

const MspReportTable = ({ tableData, mspId, searchValue, onReportAdd = () => { }, onReportViewClick = () => { } }) => {
  return (
    <div className={`${styles.mspItemTable} mspItemTable ${tableData?.length > 0 ? 'has-data' : ''}`}>
      {
        tableData?.length > 0 ? <>
          <TableHeader />
          {
            tableData?.map((item) => {
              return (
              <TableDataItem
                reportId={item?.ObjectId}
                dateAdded={item?.DateAdded}
                status={item?.Status ?? ''}
                statusColor={item?.StatusColour}
                recommendations={item?.Recommendations ?? 0}
                createdBy={item?.CreatedBy}
                onViewClick={() => { onReportViewClick(mspId, item?.ObjectId) }}
                searchValue={searchValue}
              />
            )})
          }
        </> : <div className={styles.noDataBlock}>
          <div className={styles.noDataText}>No reports at the moment</div>
          {/* <div className="no-data-text">Yo can add it
            <span className="txt-blue pointer ml-1" onClick={onReportAdd}>here</span>
          </div> */}
        </div>
      }
    </div>
  )
}

export default MspReportTable;

const TableHeaders = ['Date Added', 'Status', 'Recommendations', 'Created by', '']

const TableHeader = ({ }) => (
  <div className={styles.mspItemTableHeader}>
    {
      TableHeaders?.map((headerItem) => (
        <div className={styles.headerItem}>{headerItem}</div>
      ))
    }
  </div>
)

const TableActions = {
  remove: 'remove'
}

const DropdownOptions = [
  {
    label: 'Remove',
    action: TableActions.remove,
    className: 'f-red'
  }
]

const TableDataItem = ({
  reportId,
  dateAdded,
  status,
  statusColor,
  recommendations,
  createdBy,
  searchValue = "",
  onViewClick = () => { }
}) => {
  const { setEntityData: setRemovePortlandReportFlagger } = useEntity({ entityType: Flaggers.RemovePortlandReportFlagger });
  const handleAction = (action) => {
    switch (action) {
      case TableActions.remove:
        setRemovePortlandReportFlagger({
          show: true,
          reportId,
        }, FlaggersMethods.UpdateFlagger);
        break;
      default:
        break;
    }
  }
  return (
    <div className={`${styles.mspReportDataItem} bg-hover-lightblue  hover-on-show-parent`}>
      <div className="d-flex align-items-center justify-content-between">
        <img src={"/images/actioncenter/dateicon.svg"} width={13} height={13} alt="calendar icon" className="mb-1 mr-2" />
        <div className={styles.text}>{formatDate(dateAdded)}</div>
      </div>
      <div className={styles.statusItem} style={{ background: statusColor }}>{status}</div>
      <div className={styles.text}>{recommendations}</div>
      <div className={styles.text}>
        <span 
          dangerouslySetInnerHTML={{ __html: HGHighlightText(createdBy, searchValue) }}
        />
      </div>
      <div className="d-flex align-items-center justify-content-between gap-16">
        <div className="d-flex hover-on-show-child" onClick={onViewClick}>
          <div className={styles.blueText}>View Details</div>
          <img src={"/images/supply-chain/blue-redirect.svg"} width={15} height={15} alt="redirect icon" className="mb-1 ml-2" />
        </div>
        <Dropdown className="transparennt-wrapper-dropdown my-dropdown my-dropdown-common">
          <Dropdown.Toggle className="hover-on-show-child">
            <img
                alt=""
                width={15}
                src={"/images/settings-v2/horizontal-dots.svg"}
                className="pointer"
            />
          </Dropdown.Toggle>
          <Dropdown.Menu className="menu" popperConfig={{ strategy: 'fixed' }} renderOnMount>
            {DropdownOptions.map((option) => (
              <div className={cn("item", option.className)} onClick={() => handleAction(option.action)}>
                {option.label}
              </div>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

function formatDate(dateStr) {
  const date = new Date(dateStr);
  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
}